import { Component } from '@angular/core';

@Component({
  selector: 'psicoanecdotas',
  templateUrl: './psicoanecdotas.component.html',
  styleUrls: ['./psicoanecdotas.component.css']
})
export class PsicoanecdotasComponent {
}
